import { FC, PropsWithChildren } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const AppLayout: FC<PropsWithChildren> = ({ children }) => {
    return (
        <>
            <Navbar/>
            {children}
            {/*<Footer/>*/}
        </>
    );
};

export default AppLayout;

